import axios from 'axios';

export const AxiosPromise = async (
  method: string,
  url: string,
  data?: any,
  params?: { [key: string]: any },
  contentType?: string
): Promise<any> => {
  const accessToken = localStorage.getItem('beadvize-accessToken');
  const accessTokenExpiration = localStorage.getItem(
    'beadvize-accessTokenExpiration'
  )
    ? parseFloat(localStorage.getItem(
        'beadvize-accessTokenExpiration'
      ) as string)
    : 0;

  if (accessTokenExpiration > Date.now()) {
    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
  }

  return axios({
    data,
    headers: {
      'Content-Type': contentType ? contentType : 'application/json',
    },
    method,
    params,
    url,
  });
};



// WEBPACK FOOTER //
// ./src/utils/axios.ts